package com.eladfinish.bible.contest.utils

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.ChumashItem
import com.eladfinish.bible.contest.data.ParashaItem
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.entities.Parashot
import com.eladfinish.bible.contest.extensions.convertToDataClass
import com.eladfinish.bible.contest.parashot
import com.eladfinish.bible.contest.parashot_json
import io.github.aakira.napier.Napier

class GetParashotUseCase(
    assetReader: AssetReader,
) {

    private val parashotMapping: String by lazy { assetReader.readFile(SharedRes.assets.parashot.parashot_json) }

    private val chumashim by lazy { parashotMapping.convertToDataClass<List<ChumashItem>>() }

    fun getParashaByBookChapterAndVerse(
        book: String,
        chapter: String,
        verse: String,
    ): String {
        val chapterNum = chapter.gematriaWord()
        val verseNum = verse.gematriaWord()
        Napier.d("book $book, chapterNum: $chapterNum, verseNum: $verseNum")
        var lastParashah = ""
        if (parashotMapping.isEmpty()) {
            return lastParashah
        }

        for (i in chumashim.indices) {
            val chumashDetails: ChumashItem = chumashim[i]
            val chumash = chumashDetails.name
            if (chumash != book) {
                continue
            }
            val parashotArray = chumashDetails.parashot
            for (j in parashotArray.indices) {
                val parashahDetails: ParashaItem = parashotArray[j]
                val name = parashahDetails.name
                val c1 = parashahDetails.chapterStart
                val v1 = parashahDetails.verseStart
                val currentChapterNum = c1.gematriaWord()
                val currentVerseNum = v1.gematriaWord()

                // look for a parashah with the biggest chapter value that still
                // smaller than or equals to the chapter from search result.
                if (chapterNum >= currentChapterNum) {
                    val temp = lastParashah
                    lastParashah = name
                    if (chapterNum == currentChapterNum && verseNum < currentVerseNum) {
                        lastParashah = temp
                    }
                } else {
                    break
                }
            }
        }
        return lastParashah
    }

    fun parseParashot(bookNumber: Int, connected: Boolean = true): Parashot {
        require(bookNumber in 1..5) {
            "book must be in range 1...5, was $bookNumber"
        }
        return parseParashotInternal(parashotMapping, bookNumber, connected)
    }

    private fun parseParashotInternal(data: String, bookNumber: Int, connected: Boolean = true): Parashot {
        validateBook(bookNumber)
        val parashotArrayList = ArrayList<String>()
        val parashotSourcesArrayList = ArrayList<String>()

        val chumashim = data.convertToDataClass<List<ChumashItem>>()
        val (_, _, parashot) = chumashim[bookNumber - 1]

        var firstConnectedParasha = ""
        var firstConnectedSource = ""

        parashot.forEach { parasha ->
            val name = parasha.name
            parashotArrayList.add(name)
            parashotSourcesArrayList.add(parasha.source)
            if (connected) {
                when (parasha.pair) {
                    1 -> {
                        firstConnectedParasha = name
                        firstConnectedSource = parasha.start
                    }

                    2 -> {
                        parashotArrayList.add("$firstConnectedParasha - $name")
                        parashotSourcesArrayList.add("$firstConnectedSource-${parasha.end}")
                    }
                }
            }
        }
        return Parashot(parashotArrayList.zip(parashotSourcesArrayList))
    }

    companion object Companion {
        fun validateBook(book: Int) {
            require(book in 1..5) { "$book must be in [1,2,3,4,5]" }
        }
    }

}
